import clsx from 'clsx';
import { useCallback, useContext, useMemo, useState } from 'react';

import { ImageSize, ProductWidget, getProductImage, getProductImageAlt } from '@vestico/model';

import { GlobalsContext, useProductName } from '@vestico/shared';
import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import { MatchContentHeaderBar } from './ContentHeaderBarMatch';
import style from './productDetails.module.css';

interface OwnProps {
  product: ProductWidget | undefined | null;
  subtitle?: string;
}

export const ProductDetails = ({ product, subtitle }: OwnProps) => {
  const title = useProductName(product);
  const { useMobileLayout } = useContext(GlobalsContext);

  const productInfo = useMemo(() => {
    if (subtitle) {
      return (
        <>
          <div className={clsx(style.firstLine, globalStyle.textFontHeader, globalStyle.textNormal, globalStyle.textClampLine2)}>{title}</div>
          <div className={clsx(style.secondLine, globalStyle.textFontHeader, globalStyle.textSmall, globalStyle.textClampLine2)}>{subtitle}</div>
        </>
      );
    }
    return <div className={clsx(style.firstLine, globalStyle.textNormal, globalStyle.textClampLine2)}>{title}</div>;
  }, [subtitle, title]);

  const [imageHasError, setImageHasError] = useState(false);
  const onImageError = useCallback(() => {
    setImageHasError(true);
  }, []);

  const productWithImage = useMemo(() => {
    return (
      <>
        {product && !imageHasError ? (
          // skipcq JS-W1015
          <img
            draggable={false}
            src={getProductImage(product, ImageSize.large)}
            alt={getProductImageAlt(product)}
            className={clsx(style.image)}
            onError={onImageError}
          />
        ) : null}
        <div className={clsx(style.productInfo)}>{productInfo}</div>
      </>
    );
  }, [imageHasError, onImageError, product, productInfo]);

  return useMobileLayout ? (
    <div className={clsx(style.mobileWrapper)}>
      <MatchContentHeaderBar />
      <div className={clsx(style.root)}>{productWithImage}</div>
    </div>
  ) : (
    <div className={clsx(style.root)}>{productWithImage}</div>
  );
};
